let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cR9ju")).then(() => parcelRequire('aI0rB'));